import { clientLogos, logosLabel } from "../../data/home";
import { base } from "../../lib/links";

/**
 * Client logos in their own colors on white (white logos on a dark tile),
 * scrolling slowly. The list is
 * rendered twice so the loop is seamless; the copy is hidden from readers,
 * and from everyone when motion is reduced (the list then sits still).
 */
export default function LogoMarquee() {
  const row = (hidden) => (
    <ul
      className={
        hidden
          ? "flex shrink-0 items-center gap-14 pr-14 motion-reduce:hidden"
          : "flex shrink-0 items-center gap-14 pr-14 motion-reduce:w-full motion-reduce:shrink motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:gap-y-6 motion-reduce:pr-0"
      }
      aria-hidden={hidden || undefined}
    >
      {clientLogos.map(({ file, name, dark }) => (
        <li
          key={file}
          className={dark ? "rounded-lg bg-ink px-3 py-2" : undefined}
        >
          <img
            src={`${base}brand/clients/${file}`}
            alt={hidden ? "" : name}
            loading="lazy"
            className="h-12 w-32 object-contain md:h-14 md:w-36"
          />
        </li>
      ))}
    </ul>
  );
  return (
    <section
      aria-labelledby="clients-label"
      className="overflow-hidden border-b border-line bg-white pt-7 pb-7"
    >
      <h2
        id="clients-label"
        className="tag mb-5 px-4 text-center text-[12px] text-muted"
      >
        {logosLabel}
      </h2>
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused] motion-reduce:w-full motion-reduce:px-4">
        {row(false)}
        {row(true)}
      </div>
    </section>
  );
}
